import { useCallback, useState } from 'react'

import changeSet from 'core/change_set'

export const useLeaveWithoutPublishingConfirmation = () => {
  const [pendingUrl, setPendingUrl] = useState(null)

  const handleNavigationClick = useCallback((url, event) => {
    if (!changeSet.isDirty()) return

    event.preventDefault()
    setPendingUrl(url)
  }, [])

  const handleContinueEditing = useCallback(() => {
    setPendingUrl(null)
  }, [])

  const handleDiscard = useCallback(() => {
    const url = pendingUrl
    setPendingUrl(null)
    changeSet.reset()

    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }, [pendingUrl])

  return {
    isOpen: Boolean(pendingUrl),
    handleNavigationClick,
    handleDiscard,
    handleContinueEditing
  }
}
